<template>
  <div class="form-group">
    <label class="form-item has-label"
      v-bind:class="{'has-error': errors.has(field.key), 'form-item-disabled': field.disabled}">
      <small class="label" v-html="sanitizedFieldTitle"></small>
      <input type="number"
        class="form-control"
        v-bind:name="field.key"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        onwheel="this.blur()"
        v-validate="validationRules"
        v-bind:data-vv-as="strippedFieldTitle"
        v-bind:disabled="field.disabled"
        tabindex="1">
    </label>
    <small class="form-help-text" v-html="sanitizedHelpText"></small>
    <span class="invalid-feedback"
      v-if="errors.has(field.key)">
      {{ errors.first(field.key) }}
    </span>
  </div>
</template>

<script>
import InputMixin from '@/mixins/InputMixin';

/**
 * Input Number
 * -- Implements v-model
 *
 * A field that renders a number input, with additional numeric validation.
 */
export default {
  name: 'InputNumber',
  mixins: [
    InputMixin,
  ],
  props: {
    disabled: Boolean,
  },
  created() {
    this.validationRules.numeric = true;
  },
};
</script>
